export const FARM_SELECTOR_HIDDEN_ROUTES = [
  '/account',
  '/tempaltes',
]
